import React, { useEffect } from 'react';
import Header from './header/Header.jsx';
import Footer from './footer/Footer.jsx';
import Homepage from './homepage/Homepage.jsx';
import OverviewPage from './overviewPage/OverviewPage.jsx';
import MenuPage from './menuPage/MenuPage.jsx';
import ElementPage from './elementPage/ElementPage.jsx';
import LoadingPage from './loadingPage/LoadingPage.jsx';
import { useGlobalContext } from '../js/context.js';
import './App.scss';
import WebFont from 'webfontloader';

function App() {
	const { page } = useGlobalContext();

	useEffect(() => {
		WebFont.load({
			google: {
				families: ['Lato'],
			},
		});
	}, []);

	return (
		<div className='tos-app'>
			<Header />
			<div className='tos-content'>
				{page && page === 'home_page' && <Homepage />}
				{page && page === 'overview_page' && <OverviewPage />}
				{page && page === 'loading_page' && <LoadingPage />}
				{page && page === 'menu_page' && <MenuPage />}
				{page && page === 'element_page' && <ElementPage />}
			</div>
			<Footer />
		</div>
	);
}

export default App;
